import * as React from 'react'

function SvgTabletIcon(props) {
  return (
    <svg
      width={48}
      height={48}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      {...props}
    >
      <path
        d="M13 30a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1H13Z"
        fill="#000"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 18.05c0-2.848 0-4.271.563-5.355a5 5 0 0 1 2.132-2.132C9.78 10 11.203 10 14.05 10h19.9c2.847 0 4.271 0 5.355.563a5 5 0 0 1 2.132 2.132C42 13.78 42 15.203 42 18.05v11.9c0 2.848 0 4.271-.563 5.355a5 5 0 0 1-2.132 2.132C38.22 38 36.797 38 33.95 38h-19.9c-2.848 0-4.271 0-5.355-.563a5 5 0 0 1-2.132-2.132C6 34.22 6 32.797 6 29.95v-11.9ZM14.05 12h19.9c1.457 0 2.428.002 3.173.063.722.06 1.051.166 1.26.275.548.284.995.731 1.28 1.28.108.208.214.537.274 1.259.061.745.063 1.716.063 3.173v11.9c0 1.457-.002 2.428-.063 3.173-.06.722-.166 1.051-.275 1.26a2.999 2.999 0 0 1-1.28 1.28c-.208.108-.537.214-1.259.274-.745.061-1.716.063-3.173.063h-19.9c-1.457 0-2.428-.002-3.173-.063-.722-.06-1.051-.166-1.26-.275a3 3 0 0 1-1.28-1.28c-.108-.208-.214-.537-.273-1.259C8.002 32.378 8 31.407 8 29.95v-11.9c0-1.457.002-2.428.064-3.173.06-.722.165-1.051.274-1.26a3 3 0 0 1 1.28-1.28c.208-.108.537-.214 1.259-.274.745-.061 1.716-.063 3.173-.063Z"
        fill="#000"
      />
    </svg>
  )
}

export default SvgTabletIcon
